import { useEffect, useState } from "react";
import { Card, Drawer, Skeleton, Switch, Tabs, message } from "antd";
import { DownOutlined, InfoCircleOutlined, UpOutlined } from "@ant-design/icons";

import { useAuth } from "../../../../../../store/AuthContext/AuthContext";
import { authRequest } from "../../../../../../common/request/authRequest";
import { LocationCardCompacted } from "../../../../../components/model/business/FieldsGroup";
import { CompetitorsModal } from "../../_drawers/CompetitorsModal";
import { CompetitorsRankingPanel, GeogridVisibilityMap } from "../../_common/GeogridAndListPanel";
import { MapCompetitors } from "../../_common/MapCompetitors";
import { GeogridHistoryBar } from "../../_common/GeogridHistoryBar";
import { KeywordResultKeyword } from "../../_common/GridComponents";
import { AiReportBlockTitle, PositionDiffFactorsDashboard } from "../../_common/PositionDiffFactorsDashboard";
import { PageInfoCard } from "../../../../common/PageInfoCard";
import "../../_common/GeogridHistoryBar.css";
import "../../../../common/PageTitle.css";

const ANALISIS_AUTOGENERADO_INFO = `Este panel resume, a partir del ranking del escaneo, qué factores de SEO local parecen más relevantes en esta keyword.

- **Correlación de factores SEO Local**: peso relativo de cada factor (geolocalización y negocio) en la diferencia de posiciones del ranking.
- **Medias del ranking del TOP 10**: valores medios de los competidores mejor posicionados (distancia, puntuación, reseñas, keyword en nombre/categoría, etc.).`;

export const GeogridLocationDrawer = (props: { locationId: string, keyword: any, onFinish: any }) => {    
                    
    const [data, setData] = useState<any>(null);    
    const [history, setHistory] = useState<any>(null);    
    const [competitorsDrawer, setCompetirosDrawer] = useState<boolean>(false);    
    const [filterGridId, setFilterGridId] = useState<any>('');    
    const { projectGroup } = useAuth();
    const [currentGrid, setCurrentGrid] = useState<number>();
    const [informeMapMode, setInformeMapMode] = useState(false);
    const [analisisInfoExpanded, setAnalisisInfoExpanded] = useState(false);

    const { logOut } = useAuth();

    useEffect(() => {
        setHistory(null);            
        authRequest(
          `${process.env.REACT_APP_API}/projects/${projectGroup.project}/geogrid/historic/${props.locationId}?keyword=${props.keyword.term}`,
            { method: 'GET' }
            )
            .then((data) => {      
                setHistory(data);   
                setCurrentGrid(data.length - 1);                                                 
            })
            .catch((error) => {
                setHistory([]);
                if (error && error.status === 401) {
                    if (error.data.message === 'Google') {
                      //history.push('/vincular', { from: location });
                    } else {
                        
                    }
                }
            });            
        }, []); 

    useEffect(() => {
        
        authRequest(
          `${process.env.REACT_APP_API}/projects/${projectGroup.project}/geogrid/${projectGroup.group}/${props.locationId}?keyword=${props.keyword.term}${filterGridId}`,
            { method: 'GET' }
            )
            .then((data) => {                
                setData(data);                                              
            })
            .catch((error) => {
                if (error && error.status === 401) {
                    if (error.data.message === 'Google') {
                      //history.push('/vincular', { from: location });
                    } else {
                        message.error('Token expirado')
                        logOut();
                    }
                }
            });            
        }, [filterGridId]); 

    return (
        <>
        <Drawer
            placement="right"
            width={'90%'}
            open={true}
            onClose={props.onFinish}
            bodyStyle={{ background: '#F4F7FA', padding: '0 10px', display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}            
            headerStyle={{ background: '#F4F7FA' }}
            title={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, width: '100%' }}>
                <h2 style={{
                    color: 'slategray',
                    margin: 0,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 10,
                    flexWrap: 'wrap',
                    fontWeight: 500,
                    lineHeight: 1.3,
                    fontSize: 18,
                    minWidth: 0,
                    flex: 1,
                }}>
                    <span>Ranking de visibilidad para</span>
                    <KeywordResultKeyword
                        keyword={props.keyword.term}
                        large
                        hideScope
                    />
                </h2>
                <div style={{ flexShrink: 0, fontSize: '14px' }}>
                    <LocationCardCompacted location={data?.location} warning={false} />
                </div>
            </div>}>
                <div style={{ flexShrink: 0 }}>
                {history === null ? (
                    <div style={{ margin: '2px 10px 0', padding: '6px 12px' }}>
                        <Skeleton active title={false} paragraph={{ rows: 1, width: '55%' }} />
                    </div>
                ) : history.length > 0 ? (
                    <GeogridHistoryBar
                        history={history}
                        currentGrid={currentGrid ?? history.length - 1}
                        onSelect={(grid, index) => {
                            setFilterGridId('&id=' + grid.id);
                            setCurrentGrid(index);
                        }}
                    />
                ) : null}
                </div>
            <Card
                style={{
                    position: 'relative',
                    margin: '0 10px',
                    boxSizing: 'border-box',
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                    backgroundColor: 'transparent',
                    borderRadius: 10,
                    border: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                }}
                bodyStyle={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '0 12px 0',
                }}
            >
                {data && (
                    <Tabs
                        defaultActiveKey="informe"
                        type="line"
                        className="geogrid-drawer-tabs"
                        style={{ marginTop: 0, flex: 1, minHeight: 0 }}
                    >
                        <Tabs.TabPane tab="Global" key="informe">
                            <div style={{ display: 'flex', gap: 16, minHeight: '100%' }}>
                                <div style={{ flex: '1 1 50%', minWidth: 0 }}>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 8, paddingRight: 4 }}>
                                        <label style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            cursor: 'pointer',
                                            whiteSpace: 'nowrap',
                                            padding: '5px 10px',
                                            borderRadius: 8,
                                            background: informeMapMode ? '#ecfdf5' : 'transparent',
                                            border: informeMapMode ? '1px solid #6ee7b7' : '1px solid transparent',
                                            boxShadow: informeMapMode ? '0 0 0 2px rgba(5, 150, 105, 0.12)' : undefined,
                                            transition: 'background 0.15s, border-color 0.15s, box-shadow 0.15s',
                                        }}>
                                            <span style={{
                                                fontSize: 12,
                                                fontWeight: informeMapMode ? 700 : 500,
                                                color: informeMapMode ? '#047857' : '#94a3b8',
                                            }}>
                                                {informeMapMode ? 'Modo mapa · Activo' : 'Modo mapa'}
                                            </span>
                                            <Switch
                                                size="small"
                                                checked={informeMapMode}
                                                onChange={setInformeMapMode}
                                                style={informeMapMode ? { background: '#059669' } : undefined}
                                            />
                                        </label>
                                    </div>
                                    {informeMapMode ? (
                                        <div>
                                            <h3 style={{ marginLeft: 10, color: 'darkslategrey', marginBottom: 8 }}>
                                                Alcance de <b>{data.geoGrid.localPackMaxDistance.toFixed(0)} mts.</b> de visibilidad para <b>"{data.geoGrid.text || props.keyword.term}"</b>
                                            </h3>
                                            <p style={{ marginLeft: 10, color: 'slategray', fontSize: 13 }}>
                                                <InfoCircleOutlined /> El cuadro blanco marca la zona de grid analizada:{' '}
                                                <b>{2 * data.geoGrid.radiusParts + 1}x{2 * data.geoGrid.radiusParts + 1} puntos; {data.geoGrid.radius}</b> metros alrededor del negocio
                                            </p>
                                            <div style={{ width: '100%', height: '60vh', borderRadius: 16, overflow: 'hidden', position: 'relative', background: '#f8fafc' }}>
                                                <MapCompetitors geogrid={data.geoGrid} />
                                            </div>
                                        </div>
                                    ) : (
                                        <CompetitorsRankingPanel geogrid={data.geoGrid} hideTitle />
                                    )}
                                </div>
                                {(() => {
                                        const placesStats = data.geoGrid?.allPlacesStats || [];
                                        const missingOwn = !placesStats.some((place: any) => place.reference);
                                        const keywordLabel = data.geoGrid?.text || props.keyword?.term || '';

                                        return (
                                <div style={{ flex: '1 1 50%', minWidth: 0 }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 14,
                                        padding: '14px 16px 16px',
                                        borderRadius: 12,
                                        background: 'linear-gradient(180deg, #ede9fe 0%, #f5f3ff 38%, #ffffff 100%)',
                                        border: '1px solid #a78bfa',
                                        minHeight: '70vh',
                                        maxHeight: '70vh',
                                        overflowY: 'auto',
                                    }}>
                                        <div style={{ flexShrink: 0 }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8,
                                            }}>
                                                <span style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: 28,
                                                    height: 28,
                                                    borderRadius: 8,
                                                    background: '#7c3aed',
                                                    color: '#ffffff',
                                                    flexShrink: 0,
                                                }}>
                                                    <span className="material-symbols-outlined" style={{ fontSize: 16, color: '#ffffff' }}>auto_awesome</span>
                                                </span>
                                                <div style={{
                                                    fontSize: 14,
                                                    fontWeight: 700,
                                                    color: '#5b21b6',
                                                    lineHeight: 1.2,
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: 8,
                                                }}>
                                                    Análisis autogenerado
                                                    <button
                                                        type="button"
                                                        className="page-info-icon"
                                                        aria-label={analisisInfoExpanded ? 'Ocultar información' : 'Mostrar información'}
                                                        aria-expanded={analisisInfoExpanded}
                                                        onClick={() => setAnalisisInfoExpanded((prev) => !prev)}
                                                        style={{ flexShrink: 0 }}
                                                    >
                                                        {analisisInfoExpanded ? <UpOutlined /> : <DownOutlined />}
                                                    </button>
                                                </div>
                                            </div>
                                            {analisisInfoExpanded && (
                                                <div style={{ marginTop: 12 }}>
                                                    <PageInfoCard
                                                        title="Info"
                                                        description={ANALISIS_AUTOGENERADO_INFO}
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        {missingOwn && (
                                            <div style={{
                                                padding: '12px 14px',
                                                borderRadius: 10,
                                                background: 'rgba(255,255,255,0.72)',
                                                border: '1px solid #ddd6fe',
                                            }}>
                                                <AiReportBlockTitle>
                                                    No aparece tu negocio en este ranking
                                                </AiReportBlockTitle>
                                                <div style={{
                                                    fontSize: 12,
                                                    color: '#64748b',
                                                    lineHeight: 1.45,
                                                }}>
                                                    {keywordLabel ? (
                                                        <>Para la keyword <b style={{ color: '#475569' }}>«{keywordLabel}»</b> no eres relevante, es decir tu negocio no aparece en las búsquedas locales</>
                                                    ) : (
                                                        <>No eres relevante para esta keyword, es decir tu negocio no aparece en las búsquedas locales</>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        <PositionDiffFactorsDashboard factors={data.geoGrid?.positionDiffFactors} />
                                    </div>
                                </div>
                                        );
                                    })()}
                            </div>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Por coordenadas" key="geogrid">
                            <GeogridVisibilityMap geogrid={data.geoGrid} keyword={props.keyword?.term} />
                        </Tabs.TabPane>
                    </Tabs>
                )}
            </Card>            
        </Drawer>            

        {competitorsDrawer && 
            <CompetitorsModal 
                keyword={props.keyword} 
                locationId={props.locationId}
                onClose={() => {setCompetirosDrawer(false);}}/>}										                
        </>
    );
};
